import { render, staticRenderFns } from "./auditarticle.vue?vue&type=template&id=354bbc4c&scoped=true&"
import script from "./auditarticle.vue?vue&type=script&lang=js&"
export * from "./auditarticle.vue?vue&type=script&lang=js&"
import style0 from "./auditarticle.vue?vue&type=style&index=0&id=354bbc4c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354bbc4c",
  null
  
)

export default component.exports